import * as React from "react";
import Modal from "react-bootstrap/Modal";

const useDialogBox = () => {
  const [open, setOpen] = React.useState(false);

  const handleClose = () => {
    setOpen(false);
  };

  const DialogJSX = (props) => {
    return (
      <>
        {/* Popup model Dialog */}

        <div className="ModalBox">
          {/* Start Delete Modal */}
          <Modal show={open} onHide={handleClose}>
            <Modal.Header closeButton onClick={handleClose}>
              <Modal.Title>{props.title}</Modal.Title>
            </Modal.Header>
            <Modal.Body>{props.bodyTitle}</Modal.Body>
            <Modal.Footer>
              <button
                className="secondary"
                variant="secondary"
                onClick={handleClose}
              >
                No
              </button>

              <button
                className="primary"
                variant="primary"
                onClick={props.final}
                // ref={props.ref}
              >
                Yes
              </button>
            </Modal.Footer>
          </Modal>
          {/* End delete Modal */}
        </div>

        {/* End Popup model Dialog */}
      </>
    );
  };
  return [setOpen, DialogJSX];
};

export default useDialogBox;
